import { connect } from 'react-redux';
import EditRouteModal from '../../components/Dispatch/EditRouteModal';
import { saveRouteEdits } from '../../actions/dispatch_actions';

function mapStateToProps(state) {
  return {
    // savingNewRoute: state.dispatch.savingNewRoute,
    // saveNewRouteSuccess: state.dispatch.saveNewRouteSuccess,
    // saveNewRouteError: state.dispatch.saveNewRouteError,
    savingRouteEdits: state.dispatch.savingRouteEdits,
    saveRouteEditsSuccessful: state.dispatch.saveRouteEditedSuccessful,
  };
}

export default connect(mapStateToProps, { saveRouteEdits })(EditRouteModal);



// WEBPACK FOOTER //
// ./master/jsx/containers/Dispatch/EditRouteModal.jsx